<template>
    <tour :steps="tourSteps">
        <div class="content-wrapper">
            <div id="scheduling-admin-empresa">
                <PageHeader screenName="Agendamentos" :linkItems="linkItems"/>
                <listagem-AE v-if="verifyAEAccess"/>
            </div>
            <listagem-SESI v-if="verifySESIAccess"/>

        </div>
    </tour>

</template>

<script>

import listagemSESI from "@/views/custom-pages/agendamento/listagens/Listagem-SESI";
import listagemAE from "@/views/custom-pages/agendamento/listagens/Listagem-AE";
import PageHeader from '@/views/components/custom/page-header/PageHeader.vue'
import { actions, subjects } from "@/libs/acl/rules";
import tourMixin from "@/mixins/tourMixin";

export default {

    components: {
        listagemSESI, listagemAE,
        PageHeader
    },

    mixins: [tourMixin],

    computed: {
        verifySESIAccess() {
            return this.$can(actions.VISUALIZAR, subjects.AGENDAMENTO_SESI) || this.$can(actions.VISUALIZAR, subjects.AGENDAMENTO_SESI_UO);
        },

        verifyAEAccess() {
            return this.$can(actions.VISUALIZAR, subjects.AGENDAMENTO_AE);
        }
    },

    data() {
        return {
            linkItems: [
                {
                    name: 'Agendamentos',
                    active: true
                },
                {
                    name: 'Ver Agendamentos',
                    active: true
                }
           ]
        }
    },

    created() {
        if(!this.verifySESIAccess && !this.verifyAEAccess) {
            this.$router.push({ name: 'misc-not-authorized' })
        }
    }
}
</script>
